<template>
  <el-dialog
    title="选择规格"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose"
  >
    <el-card>
      <el-row :gutter="20">
        <el-col :span="18"></el-col>
        <el-col :span="6">
          <el-input
            placeholder="输入商品规格名称"
            v-model="chooseProductSpecInfo._currentProductSpecName"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="queryProductSpecs"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>

      <el-table
        :data="chooseProductSpecInfo.productSpecs"
        style="width: 100%; margin-top: 15px"
        border
      >
        <el-table-column prop="specId" label="规格ID" align="center"></el-table-column>
        <el-table-column prop="specName" label="规格名称" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="chooseProductSpec(scope.row)"
            >选择</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
        style="margin-top: 20px; text-align: right"
      ></el-pagination>
    </el-card>
  </el-dialog>
</template>

<script>
import { queryProductSpec } from '@/api/goods/productApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ChooseProductSpec',
  props: {
    emitChooseProductSpec: {
      type: String,
      default: ''
    },
    emitLoadData: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      chooseProductSpecInfo: {
        productSpecs: [],
        _currentProductSpecName: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._refreshChooseProductSpecInfo()
      this._loadAllProductSpecInfo(1, 10)
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          console.log(_)
          done()
        })
        .catch(_ => {
          console.log(_)
        })
    },
    async _loadAllProductSpecInfo(page, row) {
      try {
        const params = {
          page,
          row,
          name: this.chooseProductSpecInfo._currentProductSpecName,
          shopId: getShopId()
        }
        const res = await queryProductSpec(params)
        res.data.forEach(item => {
          if (!Object.prototype.hasOwnProperty.call(item,'productSpecDetails')) {
            return
          }
          let _specValue = ""
          item.productSpecDetails.forEach(detailItem => {
            _specValue += (detailItem.detailValue + "/")
          })
          item.specValue = _specValue
        })
        this.chooseProductSpecInfo.productSpecs = res.data
        this.total = res.records
        this.currentPage = page
      } catch (error) {
        console.error('获取规格列表失败:', error)
      }
    },
    chooseProductSpec(productSpec) {
      if (Object.prototype.hasOwnProperty.call(productSpec,'name')) {
        productSpec.productSpecName = productSpec.name
      }
      this.$emit(this.emitChooseProductSpec, productSpec)
      this.$emit(this.emitLoadData, {
        productSpecId: productSpec.productSpecId
      })
      this.dialogVisible = false
    },
    queryProductSpecs() {
      this._loadAllProductSpecInfo(1, 10)
    },
    _refreshChooseProductSpecInfo() {
      this.chooseProductSpecInfo._currentProductSpecName = ""
    },
    handleCurrentChange(val) {
      this._loadAllProductSpecInfo(val, 10)
    }
  }
}
</script>